import React from 'react';
import { ProSidebarProvider } from 'react-pro-sidebar';
import Footer from '../../components/Footer/Footer';
import { DesignerSidebar } from '../../components/global/DesignerSidebar';
import Topbar from '../../components/global/Topbar';

export const DesignerDashboard = (props) => {
  const { Children } = props;
  return (
    <>
      <Topbar />
      <div className="app">
        <ProSidebarProvider>
          <DesignerSidebar />
        </ProSidebarProvider>
        <div className="content">
          <Children />
        </div>
      </div>
    </>
  );
};
